import React from 'react';
import { Select, SelectProps } from '@chakra-ui/react';
import { ITipoContrato, estadoDoTipo } from './tiposDeContrato';

interface Props extends Omit<SelectProps, 'onChange' | 'value'> {
  tipos: ITipoContrato[];
  value: string;
  onChange: (valor: string) => void;
  /** Mostra ao lado de cada tipo se o evento já tem o template dele pronto. */
  mostrarEstado?: boolean;
}

function estado(t: ITipoContrato): string {
  const texto = estadoDoTipo(t);
  return texto ? ` · ${texto}` : '';
}

/**
 * Tipo de contrato: qual modelo do evento gera o contrato do fornecedor. Os tipos vêm do
 * back (o catálogo e o estado do template de cada um no evento), não de uma lista aqui.
 */
export default function SelectTipoContrato({
  tipos,
  value,
  onChange,
  mostrarEstado = false,
  ...resto
}: Props) {
  // Enquanto os tipos carregam, o valor atual continua na lista (o select não fica vazio) — sem
  // estado: "sem template no evento" ali seria falso.
  const doCatalogo = tipos.some(t => t.valor === value);
  const opcoes = doCatalogo
    ? tipos
    : [{ valor: value, rotulo: value, arquivos: 0, confirmado: false }, ...tipos];
  return (
    <Select
      size="sm"
      fontSize="12px"
      borderRadius="md"
      value={value}
      onChange={e => onChange(e.target.value)}
      aria-label="Tipo de contrato"
      {...resto}
    >
      {opcoes.map(t => (
        <option key={t.valor} value={t.valor}>
          {t.rotulo}
          {mostrarEstado && (doCatalogo || t.valor !== value) ? estado(t) : ''}
        </option>
      ))}
    </Select>
  );
}
